export default __webpack_public_path__ + "e65f173.png";